import { DateTime } from "luxon";

function calculateNetScore(courseHandicap, holeHandicap, score) {
  if (courseHandicap > 18) {
    return (courseHandicap - 18) >= holeHandicap ? score - 2 : score - 1;
  } 
  return holeHandicap <= courseHandicap ? score - 1 : score;
}  

function isNumber(value) {
  return typeof value === "number" || !Number.isNaN(value);
}

function calculateCourseHandicap(handicap, slope, rating, par) {
  if (
    isNumber(handicap) &&
    isNumber(slope) &&
    isNumber(rating) &&
    isNumber(par)
  ) {
    return Math.round((handicap * slope) / 113 + rating - par);
  }
  return undefined;
}

function calculateQuota(grossToPar) {
  switch (grossToPar) {
    case 1:
      return 1;
    case 0:
      return 2;
    case -1:
      return 4;
    case -2:
      return 8;
    case -3:
      return 10;
    default:
      return 0;
  }
}

/**
 * Removes any non-digit symbol,
 * replaces leading two zeros with plus sign,
 * adds plus sign if it starts with 1,
 * add US country code if it doesn't start from plus sign.
 *
 * @param {*} phoneNumber in any format
 * @returns phone number in E.164 format
 */
function normalizePhoneNumber(phoneNumber) {
  if (phoneNumber) {
    let number = phoneNumber;
    number = number.replace(/[^\d+]+/gu, "");
    number = number.replace(/^00/u, "+");
    if (number.match(/^1/u)) {
      number = `+${number}`;
    }

    if (!number.match(/^\+/u)) {
      number = `+1${number}`;
    }

    return number;
  }
  return phoneNumber;
}

function formatFirestoreTimeStamp(timestamp, format) {
  if (timestamp) {
    return DateTime.fromJSDate(timestamp.toDate()).toFormat(format);
  }
  return "";
}

function formatUserName(firstName, lastName) {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  if (firstName) {
    return firstName;
  }
  if (lastName) {
    return lastName;
  }
  return "";
}

export {
  calculateNetScore,
  calculateCourseHandicap,
  calculateQuota,
  normalizePhoneNumber,
  formatFirestoreTimeStamp,
  formatUserName,
};
